import { PropsWithChildren } from 'react';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { getReCaptchaKey } from '@/components/signup/utils/environment';

const hiddenRecaptchaBadgeCss = `
	.grecaptcha-badge {
		visibility: hidden !important;
		pointer-events: none !important;
	}
`;

export const SmartReCaptcha = ({ children }: PropsWithChildren) => {
	return (
		<>
			<style>{hiddenRecaptchaBadgeCss}</style>
			<GoogleReCaptchaProvider
				reCaptchaKey={getReCaptchaKey()}
				useEnterprise={true}
				useRecaptchaNet={true}
				scriptProps={{
					async: true,
				}}
			>
				{children}
			</GoogleReCaptchaProvider>
		</>
	);
};
